import { LogoDefault } from './LogoDefault.js';

export const LogoImgHistory = (created) => {
    const logoDefault = LogoDefault();
    try {
        const images = require.context('../assets/images/history', true, /\.(webp)$/i);
        const gallery = (created) => {
            return images.keys()
                .filter(path => path.startsWith(`./${created}/`))
                .map(path => (images(path)));
        }
        return gallery(created).length > 0 ? gallery(created) : [logoDefault];
    } catch (e) {
        console.log(e);
    }
}